import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=4b8b0efe&scoped=true&"
import script from "./ErrorDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=4b8b0efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b0efe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VIcon})
